angular.module( 'acme.view.application.passes.detail', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.passes.detail.controllers',
  'acme.view.application.passes.detail.series',
  'acme.view.application.passes.detail.settings'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var passesDetail = {
        name: 'application.passes.detail',
        url: '/:id/detail',
        views: {
          "subview-main": {
            controller: 'PassesDetailController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/detail/detail.tpl.html'
          }
        },
        data: {
          pageTitle: 'View Pass Program',
          /** Secure With Permissions **/
          permissions: ['PASS_RANGES_VIEW']
        }
      };

    $stateProvider
      .state(passesDetail);
});
